import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Alert,
  Card,
  CardContent,
  Grid,
  Tooltip,
  Select,
  FormControl,
  InputLabel
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddIcon from '@mui/icons-material/Add';
import api from '../axios';
import ModuleHeader from '../components/ModuleHeader';
import Footer from '../components/Footer';

const GestaoVisitantes = ({ onLogout }) => {
  const [visitantes, setVisitantes] = useState([]);
  const [consolidadores, setConsolidadores] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [filtroMes, setFiltroMes] = useState('');
  const [filtroAno, setFiltroAno] = useState(new Date().getFullYear().toString());
  const [filtroSexo, setFiltroSexo] = useState('');
  const [filtroStatus, setFiltroStatus] = useState('');
  const [filtroDistribuido, setFiltroDistribuido] = useState('');
  
  const [dialogDelete, setDialogDelete] = useState(false);
  const [dialogEdit, setDialogEdit] = useState(false);
  const [dialogReassign, setDialogReassign] = useState(false);
  const [visitanteSelecionado, setVisitanteSelecionado] = useState(null);
  const [novoConsolidadorId, setNovoConsolidadorId] = useState('');
  const [isNovo, setIsNovo] = useState(false);
  
  // Form de edição
  const [formEdit, setFormEdit] = useState({
    nome: '',
    email: '',
    telefone_celular: '',
    telefone_fixo: '',
    endereco: '',
    numero: '',
    bairro: '',
    cidade: '',
    estado: '',
    cep: '',
    sexo: '',
    status_contato: 'nao_contactado',
    quer_ser_membro: false,
    deseja_oracao: false,
    quer_conhecer_jesus: false
  });
  
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const [stats, setStats] = useState({
    total: 0,
    distribuidos: 0,
    nao_distribuidos: 0,
    contatados: 0,
    atrasados: 0
  });

  useEffect(() => {
    Promise.all([fetchVisitantes(), fetchConsolidadores()]);
  }, []);

  useEffect(() => {
    fetchVisitantes();
  }, [filtroMes, filtroAno, filtroSexo, filtroStatus, filtroDistribuido]);

  const fetchVisitantes = async () => {
    try {
      const params = {};
      if (filtroMes) params.mes = parseInt(filtroMes);
      if (filtroAno) params.ano = parseInt(filtroAno);
      if (filtroSexo) params.sexo = filtroSexo;
      if (filtroStatus) params.status_contato = filtroStatus;
      if (filtroDistribuido === 'sim') params.distribuido = true;
      if (filtroDistribuido === 'nao') params.distribuido = false;

      const response = await api.get('/visitantes/', { params });
      setVisitantes(response.data);
      calcularStats(response.data);
    } catch (error) {
      console.error('Erro ao buscar visitantes:', error);
      setError('Erro ao carregar visitantes');
    } finally {
      setLoading(false);
    }
  };

  const fetchConsolidadores = async () => {
    try {
      const response = await api.get('/consolidadores/', {
        params: { ativo: true, disponivel: true }
      });
      setConsolidadores(response.data);
    } catch (error) {
      console.error('Erro ao buscar consolidadores:', error);
    }
  };

  const calcularStats = (dados) => {
    const total = dados.length;
    const distribuidos = dados.filter(v => v.distribuido).length;
    const nao_distribuidos = total - distribuidos;
    const contatados = dados.filter(v => v.status_contato !== 'nao_contactado').length;
    const atrasados = dados.filter(v => {
      // Simular verificação de prazo (backend retorna se está atrasado)
      return v.distribuido && v.status_contato === 'nao_contactado';
    }).length;
    
    setStats({ total, distribuidos, nao_distribuidos, contatados, atrasados });
  };

  const handleAbrirDialogEdit = (visitante) => {
    setVisitanteSelecionado(visitante);
    setIsNovo(false);
    setFormEdit({
      nome: visitante.nome || '',
      email: visitante.email || '',
      telefone_celular: visitante.telefone_celular || visitante.telefone || '',
      telefone_fixo: visitante.telefone_fixo || '',
      endereco: visitante.endereco || '',
      numero: visitante.numero || '',
      bairro: visitante.bairro || '',
      cidade: visitante.cidade || '',
      estado: visitante.estado || '',
      cep: visitante.cep || '',
      sexo: visitante.sexo || '',
      status_contato: visitante.status_contato || 'nao_contactado',
      quer_ser_membro: visitante.quer_ser_membro || false,
      deseja_oracao: visitante.deseja_oracao || false,
      quer_conhecer_jesus: visitante.quer_conhecer_jesus || false,
      culto: visitante.culto || '',
      data_presenca: visitante.data_presenca || '',
      consolidador_id: visitante.consolidador_id || ''
    });
    setDialogEdit(true);
  };

  const handleAbrirNovo = () => {
    setVisitanteSelecionado(null);
    setIsNovo(true);
    setFormEdit({
      nome: '', email: '', telefone_celular: '', telefone_fixo: '',
      endereco: '', numero: '', bairro: '', cidade: '', estado: '', cep: '',
      sexo: '', status_contato: 'nao_contactado',
      quer_ser_membro: false, deseja_oracao: false, quer_conhecer_jesus: false,
      culto: '', data_presenca: '', consolidador_id: ''
    });
    setDialogEdit(true);
  };

  const handleAbrirDialogDelete = (visitante) => {
    setVisitanteSelecionado(visitante);
    setDialogDelete(true);
  };

  const handleSalvarEdicao = async () => {
    try {
      if (!formEdit.nome || !formEdit.sexo) {
        setError('Nome e sexo são obrigatórios');
        return;
      }

      if (isNovo) {
        await api.post('/visitantes/', formEdit);
        setSuccess('Visitante cadastrado com sucesso');
      } else {
        await api.put(`/visitantes/${visitanteSelecionado.id}`, formEdit);
        setSuccess('Visitante atualizado com sucesso');
      }
      setDialogEdit(false);
      fetchVisitantes();
    } catch (error) {
      const det = error.response?.data?.detail;
      setError(Array.isArray(det) ? det.map(e => e.msg).join('; ') : det || 'Erro ao atualizar visitante');
    }
  };

  const handleDeletar = async () => {
    try {
      await api.delete(`/visitantes/${visitanteSelecionado.id}`);
      
      setSuccess('Visitante removido com sucesso');
      setDialogDelete(false);
      fetchVisitantes();
    } catch (error) {
      const det = error.response?.data?.detail;
      setError(Array.isArray(det) ? det.map(e => e.msg).join('; ') : det || 'Erro ao remover visitante');
    }
  };

  const handleAbrirDialogReassign = async (visitante) => {
    setVisitanteSelecionado(visitante);
    setNovoConsolidadorId('');
    setDialogReassign(true);
  };

  const handleReassign = async () => {
    if (!novoConsolidadorId) {
      setError('Selecione um consolidador');
      return;
    }

    try {
      // Primeiro, libera o visitante atual
      const distribuicoesResponse = await api.get(`/distribuicoes/consolidador/${visitanteSelecionado.consolidador_id}`);
      const distribuicao = distribuicoesResponse.data.find(d => d.visitante_id === visitanteSelecionado.id);
      
      if (distribuicao) {
        await api.post(`/distribuicoes/${distribuicao.distribuicao_id}/liberar`);
      }
      
      setSuccess('Visitante redistribuído com sucesso');
      setDialogReassign(false);
      fetchVisitantes();
    } catch (error) {
      const det = error.response?.data?.detail;
      setError(Array.isArray(det) ? det.map(e => e.msg).join('; ') : det || 'Erro ao redistribuir visitante');
    }
  };

  const formatarData = (dataISO) => {
    if (!dataISO) return '-';
    const data = new Date(dataISO);
    return data.toLocaleDateString('pt-BR');
  };

  const meses = [
    { value: '1', label: 'Janeiro' },
    { value: '2', label: 'Fevereiro' },
    { value: '3', label: 'Março' },
    { value: '4', label: 'Abril' },
    { value: '5', label: 'Maio' },
    { value: '6', label: 'Junho' },
    { value: '7', label: 'Julho' },
    { value: '8', label: 'Agosto' },
    { value: '9', label: 'Setembro' },
    { value: '10', label: 'Outubro' },
    { value: '11', label: 'Novembro' },
    { value: '12', label: 'Dezembro' }
  ];

  const statusOptions = [
    { value: 'nao_contactado', label: 'Não Contactado' },
    { value: 'primeiro_contato', label: 'Primeiro Contato' },
    { value: 'segundo_contato', label: 'Segundo Contato' },
    { value: 'deseja_visita', label: 'Deseja Visita' },
    { value: 'deseja_oracao', label: 'Deseja Oração' },
    { value: 'pretende_ficar', label: 'Pretende Ficar' },
    { value: 'nao_encontrado', label: 'Não Encontrado' }
  ];

  return (
    <>
      <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
        <ModuleHeader module="Consolidação" title="Gestão de Visitantes" />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleAbrirNovo}>
            Novo visitante
          </Button>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
            {success}
          </Alert>
        )}

        {/* Cards de Estatísticas */}
        <Grid container spacing={2} sx={{ mb: 4 }}>
          <Grid item xs={6} md={2.4}>
            <Card>
              <CardContent>
                <Typography color="text.secondary" variant="caption">
                  Total
                </Typography>
                <Typography variant="h4" sx={{ fontSize: '4.4rem', lineHeight: 1 }}>{stats.total}</Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6} md={2.4}>
            <Card>
              <CardContent>
                <Typography color="text.secondary" variant="caption">
                  Distribuídos
                </Typography>
                <Typography variant="h4" color="primary.main" sx={{ fontSize: '4.4rem', lineHeight: 1 }}>
                  {stats.distribuidos}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6} md={2.4}>
            <Card>
              <CardContent>
                <Typography color="text.secondary" variant="caption">
                  Não Distribuídos
                </Typography>
                <Typography variant="h4" color="warning.main" sx={{ fontSize: '4.4rem', lineHeight: 1 }}>
                  {stats.nao_distribuidos}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6} md={2.4}>
            <Card>
              <CardContent>
                <Typography color="text.secondary" variant="caption">
                  Contatados
                </Typography>
                <Typography variant="h4" color="success.main" sx={{ fontSize: '4.4rem', lineHeight: 1 }}>
                  {stats.contatados}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={2.4}>
            <Card>
              <CardContent>
                <Typography color="text.secondary" variant="caption">
                  Atrasados
                </Typography>
                <Typography variant="h4" color="error.main" sx={{ fontSize: '4.4rem', lineHeight: 1 }}>
                  {stats.atrasados}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Filtros */}
        <Paper sx={{ p: 2, mb: 3 }}>
          <Typography variant="subtitle1" gutterBottom>
            Filtros
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                select
                label="Mês"
                value={filtroMes}
                onChange={(e) => setFiltroMes(e.target.value)}
                size="small"
              >
                <MenuItem value="">Todos</MenuItem>
                {meses.map(m => (
                  <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                label="Ano"
                value={filtroAno}
                onChange={(e) => setFiltroAno(e.target.value)}
                size="small"
                type="number"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                select
                label="Sexo"
                value={filtroSexo}
                onChange={(e) => setFiltroSexo(e.target.value)}
                size="small"
              >
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="masculino">Masculino</MenuItem>
                <MenuItem value="feminino">Feminino</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                select
                label="Status"
                value={filtroStatus}
                onChange={(e) => setFiltroStatus(e.target.value)}
                size="small"
              >
                <MenuItem value="">Todos</MenuItem>
                {statusOptions.map(s => (
                  <MenuItem key={s.value} value={s.value}>{s.label}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                select
                label="Distribuição"
                value={filtroDistribuido}
                onChange={(e) => setFiltroDistribuido(e.target.value)}
                size="small"
              >
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="sim">Distribuídos</MenuItem>
                <MenuItem value="nao">Não Distribuídos</MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </Paper>

        {/* Tabela de Visitantes */}
        <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Nome</TableCell>
                <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Contato</TableCell>
                <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Sexo</TableCell>
                <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Distribuído</TableCell>
                <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Motivos</TableCell>
                <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Origem</TableCell>
                <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }} align="center">
                  Ações
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {visitantes.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <Typography variant="body1" color="text.secondary" sx={{ py: 4 }}>
                      Nenhum visitante encontrado
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                visitantes.map((visitante) => (
                  <TableRow key={visitante.id} hover>
                    <TableCell>
                      <strong>{visitante.nome}</strong>
                    </TableCell>
                    <TableCell>
                      <Box display="flex" flexDirection="column" gap={0.5}>
                        {(visitante.telefone_celular || visitante.telefone_fixo) && (
                          <Box display="flex" alignItems="center" gap={0.5}>
                            <PhoneIcon fontSize="small" color="action" />
                            <Typography variant="caption">
                              {visitante.telefone_celular || visitante.telefone_fixo}
                            </Typography>
                          </Box>
                        )}
                        {visitante.email && (
                          <Box display="flex" alignItems="center" gap={0.5}>
                            <EmailIcon fontSize="small" color="action" />
                            <Typography variant="caption">
                              {visitante.email}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={visitante.sexo}
                        size="small"
                        color={visitante.sexo === 'masculino' ? 'primary' : 'secondary'}
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={
                          statusOptions.find(s => s.value === visitante.status_contato)?.label ||
                          visitante.status_contato
                        }
                        size="small"
                        color={visitante.status_contato === 'nao_contactado' ? 'warning' : 'success'}
                      />
                    </TableCell>
                    <TableCell>
                      {visitante.distribuido ? (
                        <Chip label="Sim" size="small" color="success" icon={<CheckCircleIcon />} />
                      ) : (
                        <Chip label="Não" size="small" color="error" icon={<WarningIcon />} />
                      )}
                    </TableCell>
                    <TableCell>
                      <Box display="flex" flexWrap="wrap" gap={0.5}>
                        {visitante.quer_ser_membro && (
                          <Chip label="Membro" size="small" variant="outlined" />
                        )}
                        {visitante.deseja_oracao && (
                          <Chip label="Oração" size="small" variant="outlined" />
                        )}
                        {visitante.quer_conhecer_jesus && (
                          <Chip label="Jesus" size="small" variant="outlined" />
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={visitante.origem_cadastro || 'manual'}
                        size="small"
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Box display="flex" gap={1} justifyContent="center" flexWrap="wrap">
                        <Tooltip title="Editar">
                          <IconButton
                            size="small"
                            onClick={() => handleAbrirDialogEdit(visitante)}
                            color="primary"
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        {visitante.distribuido && (
                          <Tooltip title="Redistribuir">
                            <IconButton
                              size="small"
                              onClick={() => handleAbrirDialogReassign(visitante)}
                              color="info"
                            >
                              <SwapHorizIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                        <Tooltip title="Remover">
                          <IconButton
                            size="small"
                            onClick={() => handleAbrirDialogDelete(visitante)}
                            color="error"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Dialog Editar */}
        <Dialog open={dialogEdit} onClose={() => setDialogEdit(false)} maxWidth="md" fullWidth>
          <DialogTitle>{isNovo ? 'Cadastrar Visitante' : 'Editar Visitante'}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Nome *"
                  value={formEdit.nome}
                  onChange={(e) => setFormEdit({ ...formEdit, nome: e.target.value })}
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Email"
                  type="email"
                  value={formEdit.email}
                  onChange={(e) => setFormEdit({ ...formEdit, email: e.target.value })}
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  select
                  label="Sexo *"
                  value={formEdit.sexo}
                  onChange={(e) => setFormEdit({ ...formEdit, sexo: e.target.value })}
                >
                  <MenuItem value="masculino">Masculino</MenuItem>
                  <MenuItem value="feminino">Feminino</MenuItem>
                </TextField>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Telefone Celular"
                  value={formEdit.telefone_celular}
                  onChange={(e) => setFormEdit({ ...formEdit, telefone_celular: e.target.value })}
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Telefone Fixo"
                  value={formEdit.telefone_fixo}
                  onChange={(e) => setFormEdit({ ...formEdit, telefone_fixo: e.target.value })}
                />
              </Grid>
              
              <Grid item xs={12} md={8}>
                <TextField
                  fullWidth
                  label="Endereço"
                  value={formEdit.endereco}
                  onChange={(e) => setFormEdit({ ...formEdit, endereco: e.target.value })}
                />
              </Grid>
              
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Número"
                  value={formEdit.numero}
                  onChange={(e) => setFormEdit({ ...formEdit, numero: e.target.value })}
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Bairro"
                  value={formEdit.bairro}
                  onChange={(e) => setFormEdit({ ...formEdit, bairro: e.target.value })}
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Cidade"
                  value={formEdit.cidade}
                  onChange={(e) => setFormEdit({ ...formEdit, cidade: e.target.value })}
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Estado"
                  value={formEdit.estado}
                  onChange={(e) => setFormEdit({ ...formEdit, estado: e.target.value })}
                  inputProps={{ maxLength: 2 }}
                  placeholder="UF"
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="CEP"
                  value={formEdit.cep}
                  onChange={(e) => setFormEdit({ ...formEdit, cep: e.target.value })}
                />
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Status de Contato"
                  value={formEdit.status_contato}
                  onChange={(e) => setFormEdit({ ...formEdit, status_contato: e.target.value })}
                >
                  {statusOptions.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  select
                  label="Esteve presente na:"
                  value={formEdit.culto}
                  onChange={(e) => setFormEdit({ ...formEdit, culto: e.target.value })}
                >
                  <MenuItem value="">Selecione</MenuItem>
                  {['Culto de Domingo (Manhã)', 'Culto de Domingo (Noite)', 'Culto Fé', 'Culto Shine', 'Culto Rocket', 'Culto Legacy', 'Outros'].map(o => (
                    <MenuItem key={o} value={o}>{o}</MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Data de presença"
                  InputLabelProps={{ shrink: true }}
                  value={formEdit.data_presenca}
                  onChange={(e) => setFormEdit({ ...formEdit, data_presenca: e.target.value })}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  select
                  label="Consolidador responsável (ativo e disponível)"
                  value={formEdit.consolidador_id || ''}
                  onChange={(e) => setFormEdit({ ...formEdit, consolidador_id: e.target.value })}
                >
                  <MenuItem value="">Sem consolidador</MenuItem>
                  {(consolidadores || []).map(c => (
                    <MenuItem key={c.id} value={c.id}>{c.nome}</MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>
                  Interesses
                </Typography>
                <Box display="flex" gap={2} flexWrap="wrap">
                  <FormControl>
                    <label>
                      <input
                        type="checkbox"
                        checked={formEdit.quer_ser_membro}
                        onChange={(e) => setFormEdit({ ...formEdit, quer_ser_membro: e.target.checked })}
                      />
                      {' '}Quer ser membro
                    </label>
                  </FormControl>
                  <FormControl>
                    <label>
                      <input
                        type="checkbox"
                        checked={formEdit.deseja_oracao}
                        onChange={(e) => setFormEdit({ ...formEdit, deseja_oracao: e.target.checked })}
                      />
                      {' '}Deseja oração
                    </label>
                  </FormControl>
                  <FormControl>
                    <label>
                      <input
                        type="checkbox"
                        checked={formEdit.quer_conhecer_jesus}
                        onChange={(e) => setFormEdit({ ...formEdit, quer_conhecer_jesus: e.target.checked })}
                      />
                      {' '}Quer conhecer Jesus
                    </label>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialogEdit(false)}>Cancelar</Button>
            <Button onClick={handleSalvarEdicao} variant="contained" color="primary">
              {isNovo ? 'Cadastrar' : 'Salvar'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog Deletar */}
        <Dialog open={dialogDelete} onClose={() => setDialogDelete(false)} fullWidth maxWidth="sm">
          <DialogTitle>Remover Visitante</DialogTitle>
          <DialogContent>
            <Typography>
              Tem certeza que deseja remover <strong>{visitanteSelecionado?.nome}</strong>?
            </Typography>
            <Alert severity="warning" sx={{ mt: 2 }}>
              Esta ação também removerá todas as distribuições associadas e não pode ser desfeita!
            </Alert>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialogDelete(false)}>Cancelar</Button>
            <Button onClick={handleDeletar} variant="contained" color="error">
              Remover
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog Reassign */}
        <Dialog open={dialogReassign} onClose={() => setDialogReassign(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Redistribuir Visitante</DialogTitle>
          <DialogContent>
            <Typography gutterBottom>
              Visitante: <strong>{visitanteSelecionado?.nome}</strong>
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              O visitante será liberado do consolidador atual e redistribuído automaticamente
              para outro consolidador disponível do mesmo sexo.
            </Typography>
            
            <Alert severity="info">
              A redistribuição será feita automaticamente seguindo as regras de balanceamento.
            </Alert>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialogReassign(false)}>Cancelar</Button>
            <Button onClick={handleReassign} variant="contained" color="primary">
              Redistribuir
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
      <Footer />
    </>
  );
};

export default GestaoVisitantes;
